<template>
  <div>
    <form>
      <v-alert
        v-if="Object.keys(errors).length > 0"
        dense
        dismissible
        type="error"
        class="invalid-alert"
        transition="slide-y-transition"
      >
        Formuláro inválido.
      </v-alert>
      <PageHeading
        :title="which_rate == 'grade' ? 'Avaliações' : 'Metas'"
      />
      <v-container class="dates-container">
        <v-row align="center">
          <div :class="{ 'red--text': errors['date'] }">
            <p>
              <span v-if="which_rate == 'grade'">Avaliação em:</span>
              <span v-else>Prazo:</span>
                {{ formatted_date }}
            </p>
          </div>
          <v-spacer></v-spacer>

          <!-- Date picker -->
          <v-menu
            :close-on-content-click="false"
            v-model="date_edit_menu"
            left
            :nudge-width="300"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon :color="errors['date'] ? 'red' : 'black'">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-date-picker
                  v-if="which_rate == 'grade'"
                  v-model="date"
                  locale="pt"
                  :max="today"
                />
                <v-date-picker
                  v-else
                  v-model="date"
                  locale="pt"
                  :min="tomorrow"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn @click="date_edit_menu = false" text color="success">OK</v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="date_edit_menu = false" text>Cancelar</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
        </v-row>
        <v-row v-if="errors['date']">
          <div class="validation-message">
            <p>{{ errors['date'] }}</p>
          </div>
        </v-row>
      </v-container>

      <help-popup
        title="Referências para as avaliações"
      >
        <template #activator="{ on, attrs }">
          <v-row>
            <v-col>
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                color="primary"
                style="float: left"
              >Referencias</v-btn>
            </v-col>
          </v-row>
        </template>

        <template #default>
          <ul>
            <li>1 e 2 = péssimo</li>
            <li>3 e 4 = ruim</li>
            <li>5 e 6 = razoável</li>
            <li>7 e 8 = bom</li>
            <li>9 e 10 = ótimo</li>
          </ul>
        </template>
        
      </help-popup>

      <template v-for="(category, i) in sorted_categories">
        <div class="category-rating" :key="category.id">

          <!-- Category name and help button -->
          <v-row no-gutters>
            <v-col cols="10">
              <h3 class="label" :style="{ 'color': category.color }">{{ category.name }}</h3>
            </v-col>
            <v-spacer/>
            <v-col cols="2" align-self="center">
              <help-popup
                :title="category.name"
                :loading="help_loading"
                @open="load_help(`${context_id}/${category.id}`)"
                @close="help_loading = true"
                right
              >
                <div v-html="help_msg_get(`/${context_id}/${category.id}`)"></div>
              </help-popup>
            </v-col>
          </v-row>
          <div
            class="item-rating"
            v-for="item in category.items"
            :key="category.id + '/' + item.id"
          >
            <v-row>
              <v-col cols="10">
                <h4
                  class="label"
                  :class="{ 'red--text': errors[`${category.id}/${item.id}`] }"
                >
                  {{ item.name }}
                </h4>
              </v-col>
              <v-spacer/>
              <v-col cols="2" align-self="center">
                <help-popup
                  :title="item.name"
                  :loading="help_loading"
                  @open="load_help(`/${context_id}/${category.id}/${item.id}`)"
                  @close="help_loading = true"
                  right
                >
                  <div v-html="help_msg_get(`/${context_id}/${category.id}/${item.id}`)"></div>
                </help-popup>
              </v-col>
            </v-row>
            <RatingInput
              v-if="which_rate == 'grade'"
              :on-color="category.color"
              :off-color="errors[`${category.id}/${item.id}`] ? 'red' : '#404040'"
              :alt-color="category.goal_color"
              :value="item.grade"
              :alt-value="item.goal"
              v-model="item.grade"
              @input="validate_item(category, item)"
              hide-details
            ></RatingInput>
            <RatingInput
              v-else
              :on-color="category.color"
              :off-color="errors[`${category.id}/${item.id}`] ? 'red' : '#404040'"
              :alt-color="category.goal_color"
              :value="item.goal"
              :alt-value="item.grade"
              v-model="item.goal"
              @input="validate_item(category, item)"
              inverted
              hide-details
            ></RatingInput>
            <div v-if="errors[`${category.id}/${item.id}`]" class="validation-message">
              <p>{{ errors[`${category.id}/${item.id}`] }}</p>
            </div>
          </div>
        </div>
        <v-divider v-if="i < categories.length - 1" :key="'divider-' + category.id"></v-divider>
      </template>
    </form>
    <v-btn
      class="mx-2"
      fab
      fixed
      bottom
      left
      dark
      color="#802C12"
      :loading="loading"
      @click="cancel"
    >
      <v-icon dark>mdi-close</v-icon>
    </v-btn>
    <v-fab-transition>
      <v-btn
        class="mx-2"
        fab
        fixed
        bottom
        right
        dark
        color="#802C12"
        :loading="loading"
        @click="submit"
      >
        <v-icon dark>mdi-check</v-icon>
      </v-btn>
    </v-fab-transition>
    <TutorialDialog v-show="showDialog" :text="dialogMsg"/>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import RatingInput from "@/components/RatingInput.vue";
import PageHeading from "@/components/PageHeading.vue";
import TutorialDialog from "@/components/TutorialDialog.vue";
import HelpPopup from "@/components/HelpPopup.vue";

import { firestore } from '@/firebase';
import * as db from "@/db/constants";

export default {
  name: "RatingForm",
  components: {
    RatingInput,
    PageHeading,
    TutorialDialog,
    "help-popup": HelpPopup,
  },
  props: [ "group_id", "context_id", "which_rate" ],
  data() {
    return {
      errors: {},
      loading: false,
      date_edit_menu: false,
      showDialog: false,
      context: {},
      dialogMsg: "",
      help_loading: true,
      help_msgs: {},
    }
  },
  mounted() {
    if (!this.loggedIn)
      console.error("Tryied to load RatingForm.vue without a user logged in.");

    console.assert(
      ["grade", "goal"].includes(this.which_rate),
      "wich_rate route param needs to be either 'grade' or 'goal'"
    );

    if (this.is_setup) {
      this.showDialog = true;
      this.dialogMsg = "Preparação";
    }

    const cached = this.$store.getters[`user/${this.group_id}/${this.context_id}/cached`];
    // Clone the object.
    this.context = JSON.parse(JSON.stringify(cached));

    if (this.which_rate === "grade" && !this.context?.rating_date)
      this.context.rating_date = this.today;
    else if (this.which_rate === "goal" && !this.context?.goal_deadline)
      this.context.goal_deadline = this.tomorrow;
  },
  computed: {
    is_setup() { return this.$route.query.setup; },
    sorted_categories() {
      return this.categories?.slice()
        .sort((a, b) => a.id > b.id ? 1 : (a.id < b.id ? -1 : 0));
    },
    today() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    tomorrow() {
      const date = new Date();
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = (date.getDate() + 1).toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    date: {
      get() {
        if (this.which_rate === "grade") return this.rating_date;
        else return this.goal_deadline;
      },
      set(newVal) {
        if (this.which_rate === "grade") this.rating_date = newVal;
        else return this.goal_deadline = newVal;
      }
    },
    formatted_date() {
      if (this.date) {
        const parts = this.date.split("-");
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
      } else return "";
    },
    rating_date: {
      get() {
        return this.context.rating_date;
      },
      set(newVal) {
        this.context.rating_date = newVal;
        this.validate_date();
      }
    },
    goal_deadline: {
      get() {
        return this.context.goal_deadline;
      },
      set(newVal) {
        this.context.goal_deadline = newVal;
      }
    },
    categories() { return this.context.categories; },
    ...mapGetters([
      "user_id",
      "loggedIn"
    ])
  },
  methods: {
    validate_date() {
      if (this.which_rate === "grade" && this.dateCompare(this.today, this.rating_date) < 0) {
        this.errors["date"] = "Data da nota deve ser anterior ou igual a data de hoje.";
        return false;
      }
      if (this.which_rate === "goal" && this.dateCompare(this.today, this.goal_deadline) >= 0) {
        this.errors["date"] = "Data da meta deve ser posterior à data de hoje.";
        return false;
      }
      if (this.errors["date"]) {
        delete this.errors["date"];
      }
      return true
    },
    validate_item(category, item) {
      if (this.which_rate === "grade" && (!item.grade || item.grade !== Math.floor(item.grade))) {
        this.errors[`${category.id}/${item.id}`] = "A nota precisa possuir um valor válido";
        return false;
      }
      if (this.which_rate === "goal" && (!item.goal || item.goal !== Math.floor(item.goal))) {
        this.errors[`${category.id}/${item.id}`] = "A meta precisa possuir um valor válido";
        return false;
      }
      if (this.errors[`${category.id}/${item.id}`]) {
        delete this.errors[`${category.id}/${item.id}`];
      }
      return true;
    },
    validate() {
      this.errors = {};

      let valid = true;
      valid &= this.validate_date();
      for (const category of this.context.categories) {
        for (const item of category.items) {
          valid &= this.validate_item(category, item);
        }
      }
      return valid;
    },
    dateCompare(date1, date2) {
      const parts1 = date1.split("-");
      const parts2 = date2.split("-");
      if (parts1[0] > parts2[0]) return  1;
      if (parts1[0] < parts2[0]) return -1;
      if (parts1[1] > parts2[1]) return  1;
      if (parts1[1] < parts2[1]) return -1;
      if (parts1[2] > parts2[2]) return  1;
      if (parts1[2] < parts2[2]) return -1;
      return 0;
    },
    submit() {
      if (this.validate() && !this.loading) {
        this.loading = true;
        this.$store.dispatch(`user/${this.group_id}/${this.context_id}/update`, this.context)
          .then(() => {
            this.loading = false;
            this.$router.push({ name: "Context", params: { group_id: this.group_id, context_id: this.context_id }});
          })
          .catch(error => {
            console.error(error);
          });
      }
    },
    cancel() {
      this.$router.push({
        name: "Context",
        params: {
          group_id: this.group_id,
          context_id: this.context_id,
        },
      });
    },
    help_msg_get(path) {
      const res = this.help_msgs[path];
      if (!res) return "";
      
      if (res.error)
        return `<strong class='red--text'>Erro: ${res.error}<strong>`;
      else
        return res.text;
    },
    async load_help(path) {
      this.help_loading = true;
      const result = await firestore
        .collection(db.TEMPLATES_COLLECTION)
        .doc(this.context_id)
        .collection(db.DESCRIPTIONS_COLLECTION)
        .where("path", "==", path)
        .limit(1)
        .get();

      if (result.docs.length == 0) {
        this.help_msgs[path] = {
          text: null,
          error: "Descrição não pode ser encontrada."
        };
      } else {
        const doc = result.docs[0];
        const data = doc.data();

        this.help_msgs[path] = {
          db_ref: doc.ref,
          text:   data.text ?? null,
          error:  !data.text ? "Nenhum texto encontrado para essa descrição" : null,
        };
      }
      this.help_loading = false;
    },
  }
}
</script>
<style lang="scss">
.category-rating {
  margin-bottom: 2.5em;

  .item-rating {
    margin-top: 1em;
  }
}
</style>
